import { render, staticRenderFns } from "./LeonidaVisitaMedicoSportivaView.vue?vue&type=template&id=62ad56ac&scoped=true"
import script from "./LeonidaVisitaMedicoSportivaView.vue?vue&type=script&lang=js"
export * from "./LeonidaVisitaMedicoSportivaView.vue?vue&type=script&lang=js"
import style0 from "./LeonidaVisitaMedicoSportivaView.vue?vue&type=style&index=0&id=62ad56ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ad56ac",
  null
  
)

export default component.exports